import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Users, Sparkles, ArrowRight } from 'lucide-react';

export default function AuthorLanding() {
  return (
    <div className="space-y-16 pb-8">
      <section className="text-center space-y-6 py-12">
        <h1 className="text-6xl font-bold" 
            style={{ 
              background: `linear-gradient(135deg, var(--color-accent1), var(--color-accent2))`,
              WebkitBackgroundClip: 'text'
            }}>
          Your Story Starts Here
        </h1>
        <p className="text-xl max-w-2xl mx-auto" style={{ color: 'var(--color-accent2)' }}>
          Connect with readers, validate your ideas, and build your audience before you write.
        </p>
        <div className="flex justify-center gap-4">
          <Link
            to="/auth?mode=signup&role=author"
            className="px-6 py-3 rounded-lg hover:opacity-80 font-medium"
            style={{ 
              backgroundColor: 'var(--color-accent1)',
              color: 'var(--color-background)'
            }}
          >
            Join as Author
          </Link>
          <Link
            to="/auth"
            className="px-6 py-3 rounded-lg hover:opacity-80 border font-medium"
            style={{ 
              borderColor: 'var(--color-accent1)',
              color: 'var(--color-accent1)'
            }}
          >
            Sign In
          </Link>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4">
        <div className="rounded-2xl p-8 md:p-12" style={{ backgroundColor: 'var(--color-accent3)', opacity: 0.9 }}>
          <h2 className="text-3xl font-bold mb-6" style={{ color: 'var(--color-font)' }}>Why Join as an Author?</h2>
          <p className="text-lg mb-8" style={{ color: 'var(--color-font)' }}>
            StoryMuse.io provides a unique platform to validate your book ideas, gather feedback, and build an 
            engaged audience before you invest months in writing.
          </p>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="p-6 rounded-xl shadow-sm" style={{ backgroundColor: 'var(--color-background)' }}>
              <BookOpen className="w-8 h-8 mb-4" style={{ color: 'var(--color-accent1)' }} />
              <h3 className="font-semibold text-lg mb-2" style={{ color: 'var(--color-font)' }}>Test Your Ideas</h3>
              <p style={{ color: 'var(--color-font)' }}>
                Share your book concepts and get immediate feedback from potential readers.
              </p>
            </div>
            <div className="p-6 rounded-xl shadow-sm" style={{ backgroundColor: 'var(--color-background)' }}>
              <Users className="w-8 h-8 mb-4" style={{ color: 'var(--color-accent1)' }} />
              <h3 className="font-semibold text-lg mb-2" style={{ color: 'var(--color-font)' }}>Build Your Audience</h3>
              <p style={{ color: 'var(--color-font)' }}>
                Grow a following of engaged readers who are invested in your story's success.
              </p>
            </div>
            <div className="p-6 rounded-xl shadow-sm" style={{ backgroundColor: 'var(--color-background)' }}>
              <Sparkles className="w-8 h-8 mb-4" style={{ color: 'var(--color-accent1)' }} />
              <h3 className="font-semibold text-lg mb-2" style={{ color: 'var(--color-font)' }}>Perfect Your Story</h3>
              <p style={{ color: 'var(--color-font)' }}>
                Use reader insights to refine your plot, characters, and world-building.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4">
        <div className="rounded-2xl p-8 md:p-12 text-center" style={{ backgroundColor: 'var(--color-accent1)' }}>
          <h2 className="text-3xl font-bold mb-4" style={{ color: 'var(--color-background)' }}>
            Ready to Share Your Story?
          </h2>
          <p className="text-lg mb-8" style={{ color: 'var(--color-background)', opacity: 0.9 }}>
            Join StoryMuse.io today and start building your audience before you write.
          </p>
          <Link
            to="/auth?mode=signup&role=author"
            className="inline-flex items-center px-6 py-3 rounded-lg hover:opacity-80 font-medium"
            style={{ 
              backgroundColor: 'var(--color-background)',
              color: 'var(--color-accent1)'
            }}
          >
            Get Started <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </section>
    </div>
  );
}